import { useRef } from "react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import ServicesSection from "./components/ServicesSection";
import AIAnswerBlock from "./components/AIAnswerBlock";
import ProcessSection from "./components/ProcessSection";
import WhyChooseSection from "./components/WhyChooseSection";
import ServiceAreasSection from "./components/ServiceAreasSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import FinalCTASection from "./components/FinalCTASection";
import LeadFormSection from "./components/LeadFormSection";
import Footer from "./components/Footer";

export default function Home() {
  const formRef = useRef<HTMLDivElement>(null);

  const scrollToForm = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="w-full min-h-screen" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <HeroSection onGetQuote={scrollToForm} />
      <TrustBar />
      <ServicesSection onGetQuote={scrollToForm} />
      <AIAnswerBlock />
      <ProcessSection />
      <WhyChooseSection onGetQuote={scrollToForm} />
      <ServiceAreasSection />
      <TestimonialsSection onGetQuote={scrollToForm} />
      <FAQSection />
      <FinalCTASection onGetQuote={scrollToForm} />
      <LeadFormSection formRef={formRef} />
      <Footer />
    </div>
  );
}
